<template>
  <v-container class="pa-0">
    <v-row no-gutters>
      <v-col cols="12">
        <FormHeader title="PROXIES" />
      </v-col>
    </v-row>
    <v-container class="white">
      <v-layout v-for="(proxyItem, index) in proxy" :key="index">
        <v-row no-gutters align="baseline">
          <v-col cols="2" lg="1">
            <v-subheader>Tool {{
              index * 1 + 1
              }} :</v-subheader>
          </v-col>
          <v-col cols="10" class="pl-4" lg="3">
            <v-sheet>
              <v-autocomplete
                      v-model="proxyItem.tool"
                      :items="getProxyToolsList"
                      item-value="name"
                      item-text="name"
                      name="tool"
                      placeholder="Select tool"
                      dense
                      outlined
                      @input="handleSetTool"
                      :rules="[v => !!(v && Object.keys(v).length !== 0) || 'This field is required']"
              ></v-autocomplete>
            </v-sheet>
          </v-col>
          <v-col cols="2" lg="1">
            <v-subheader>Region:</v-subheader>
          </v-col>
          <v-col cols="4" class="pl-4" lg="2">
            <v-sheet>
              <v-autocomplete
                      v-model="proxyItem.region"
                      :items="handleSetTool(proxyItem.tool)"
                      name="region"
                      item-value="name"
                      item-text="name"
                      placeholder="Select region"
                      dense
                      outlined
                      @input="handleSetRegion(index, proxyItem.region, proxyItem.tool)"
                      :rules="[v => !!(v && Object.keys(v).length !== 0) || 'This field is required']"
              ></v-autocomplete>
            </v-sheet>
          </v-col>
          <v-col cols="2" lg="1">
            <v-subheader>Residential:</v-subheader>
          </v-col>
          <v-col cols="4" class="pl-4" lg="2">
            <v-sheet>
              <v-switch
                v-model="proxyItem.residential"
                name="residential"
                inset
                solo
                dense
                :readonly="proxyItem.isResidentialEnable"
              ></v-switch>
            </v-sheet>
          </v-col>
          <v-col cols="1">
            <v-btn
                    icon
                    v-if="Object.keys(proxy).length !== 1"
            >
              <v-icon @click="deleteItem(index)">mdi-delete</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-layout>
      <Button
        v-on:onClick="addProxy()"
        class="ma-3"
        :red-btn="true"
        :content="`ADD PROXY`"
        depressed
      />
    </v-container>
  </v-container>
</template>

<script>
import FormHeader from "../FormHeader";
import { createNamespacedHelpers } from "vuex";
import Button from "../../common/Button";
const formHelper = createNamespacedHelpers("form");
export default {
  name: "ProxiesForm",
  components: {
    FormHeader,
    Button
  },
  props: {
    proxy: {
      type: Array
    }
  },
  computed: {
    ...formHelper.mapGetters(["getProxyToolsList"])
  },
  methods: {
    addProxy() {
      this.$emit('add-proxy-item');
    },
    deleteItem(index) {
      this.$emit('delete-proxy-item', index);
    },
    handleSetTool(e){
      return this.getProxyToolsList?.find(item =>{
        return e === item.name
      })?.regions;
    },
    handleSetRegion(index, region, tool) {
      this.$emit('set-proxy-region-residential', index, region, tool);
    },
  }
};
</script>
